/* import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-QC1HS5W968");
};

export const trackEvent = (action, params = {}) => {
  ReactGA.event(action, params);
}; */
import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-QC1HS5W968");
};

export const trackEvent = (
  action: string,
  params: Record<string, any> = {}
) => {
  ReactGA.event(action, params);
};